import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

function CrashRoute({ classes }) {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <h1 className={classes.title}>:(</h1>
      </div>
    </div>
  );
}

export default withStyles(styles)(CrashRoute);
